module.exports = __webpack_public_path__ + "images/emoji/love_letter.0fbe67a7354dbf1e70f1.png";